<template>
    <b-modal id="createadfsuser"
             size="lg"
             ref="createAdfsUserModal"
             class="modal-backdrop"
             no-close-on-esc
             no-close-on-backdrop>
        <template slot="modal-header" class="mx-auto">
            <h5 class="modal-title" style="text-align:center;">Information</h5>
        </template>
        <template slot="default">
            <p v-if="actionFromEdit" style="background-color:#fae5e3;">
                Please select Continue to create a username and set user permissions. Once submitted, the user will receive an email to complete their profile.
            </p>
            <p v-if="!actionFromEdit" style="background-color:#fae5e3;">
                The email you entered is already associated with this account but does not have a login.
                Please select Continue to create a username and set user permissions. Once submitted, the user will receive an email to complete their profile.
            </p>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
            <b-button class="um-btn" @click="createAdfsUser()">Continue</b-button>
        </template>
        <CreateUser :isNewUser="false"
                    :userEmailId="userEmailId"
                    :accountName="accountName"
                    :accountNumber="accountNumber"
                    @OnCreateUserModalCancel="cancelChanges"
                    :accountId="accountId"></CreateUser>
    </b-modal>
</template>
<script>
    import CreateUser from "../CreateUser";
    import { eventbus } from "../../main";
    export default {
        name: "CreateAdfsUser",
        components: {
            CreateUser
        },
        props: {
            accountNumber: String,
            accountName: String,
            accountId: String,
            userEmailId: String,
            isNewUser: Boolean,
            actionFromEdit: Boolean
        },
        methods: {
            cancelChanges: function () {
                this.$emit("OnCreateAdfsUserModalCancel");
            },
            createAdfsUser: function () {
                eventbus.$emit("setuserDetails",
                    this.$store.getters.searchedUserDetail, false
                );
                if (!this.actionFromEdit)
                    this.$bvModal.hide("createadfsuser");
                this.$bvModal.show("createuser");
            },
        }
    }
</script>
<style>
</style>
